/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import classNames from 'classnames';
import type React from 'react';

import { type PolymorphicCommonProps } from '../_common/types';

type LoadingBarProps = {
  hasRail?: boolean;
};

export const LoadingBar = <T extends React.ElementType = 'div'>({
  as,
  hasRail = false,
  className,
  htmlAttributes,
  style,
  ref,
  ...restProps
}: PolymorphicCommonProps<T, LoadingBarProps>) => {
  const Component: React.ElementType = as ?? 'div';
  const classes = classNames('ndl-loading-bar', className, {
    'ndl-loading-bar-rail': hasRail,
  });

  return (
    <Component
      className={classes}
      ref={ref}
      role="status"
      style={style}
      {...restProps}
      {...htmlAttributes}
    />
  );
};
